import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from '@grupa-pracuj/react-tabs';
import PropTypes from 'prop-types';

import { sendEventClick } from 'src/api/tracker';
import { context, NEWEST, EXPIRE_SOON } from 'src/api/context';
import { getOffers } from 'src/redux/actions/offers';
import { setContext } from 'src/redux/actions/context';

import styles from 'src/containers/OfferTabsContainer.scss';

class OfferTabsContainer extends PureComponent {
  displayOffers = (selectedContext) => {
    const { dispatch } = this.props;
    dispatch(setContext(selectedContext));
    dispatch(getOffers());
  };

  render() {
    const { context: currentContext } = this.props;
    const newest = context.get(NEWEST);
    const expireSoon = context.get(EXPIRE_SOON);
    const newestText = 'Nowe oferty';
    const expireSoonText = 'Wkrótce wygasną';
    return (
      <Tabs
        customClasses={{
          customClass: styles['tabs-container'],
          customWrapper: styles['tabs-wrapper'],
          customUnderline: styles['tabs-underline'],
          customBorder: styles['tabs-border'],
        }}
        customTabClasses={{
          customClass: styles.tab,
          customActiveClass: styles['tab--active'],
        }}
        initialActiveTab={currentContext}
      >
        <Tab
          id={newest}
          onClick={() => {
            this.displayOffers(newest);
            sendEventClick('rec_tab_latest');
          }}
        >
          {newestText}
        </Tab>
        <Tab
          id={expireSoon}
          onClick={() => {
            sendEventClick('rec_tab_expiring');
            this.displayOffers(expireSoon);
          }}
        >
          {expireSoonText}
        </Tab>
      </Tabs>
    );
  }
}

OfferTabsContainer.propTypes = {
  context: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProperties = (state) => ({
  context: state.contextReducer.context,
});

export default connect(mapStateToProperties)(OfferTabsContainer);
